import { IconButton, Text } from "@/elements"
import { ChevronRightIcon } from "@heroicons/react/24/outline"
import { useRouter } from "next-nprogress-bar"
import React, { FC } from "react"

type ActionRowProps = {
  icon: React.ReactElement<any>
  text: string
  count: number | undefined
  link: string
  newCount?: number | undefined
  onClick?: () => void
}

export const ActionRow: FC<ActionRowProps> = props => {
  const router = useRouter()

  const onClick = (
    e: React.MouseEvent<HTMLDivElement, MouseEvent> | React.MouseEvent<HTMLAnchorElement, MouseEvent>
  ) => {
    e.preventDefault()
    e.stopPropagation()
    if (props.onClick) {
      props.onClick()
    }

    router.push(props.link)
  }

  return (
    <div
      onClick={onClick}
      className="flex h-[49px] w-full flex-row items-center justify-between md:pl-6 md:pr-4 hover:md:bg-bg-2">
      <div className="flex items-center">
        {props.icon}
        <Text variant="body1" className="ml-2 mr-[5px] text-fg-1 md:ml-4">
          {props.text}
        </Text>
        <Text variant="body1" className="text-fg-3">
          {props.count}
        </Text>
      </div>
      <div className="flex items-center gap-x-2">
        {Boolean(props.newCount && props.newCount > 0) && (
          <div className="flex h-5 items-center justify-center rounded-sm bg-primary-6 px-[6px]">
            <Text variant="body2" className="text-bg-1">
              {props.newCount} New
            </Text>
          </div>
        )}
        <IconButton variant="white" size="small" Icon={ChevronRightIcon} />
      </div>
    </div>
  )
}
